import React, { useState } from "react";
import { Button, Card, Result } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { logoutFromBothFirebase } from "../../../configs/FirebaseConfig";
import roles from "../../../roles";

/**
 * What someone signed in without a CMS role sees instead of the CMS: a scanner account, a webshop
 * customer, or a staff account whose role was never set. Reached from the route guard, so it also
 * covers a session that was already open - not only a fresh login.
 */
const AccessDenied = ({ email, role }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const signOut = async () => {
    setBusy(true);
    try {
      await logoutFromBothFirebase();
    } finally {
      navigate("/auth/login", { replace: true });
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <Card style={{ maxWidth: 520, width: "100%" }}>
        <Result
          status="403"
          title={t("notifications.access_denied_title")}
          subTitle={
            <>
              <div>{role === roles.picker ? t("notifications.picker_login_refused") : t("notifications.unauthorized_user")}</div>
              {!!email && <div style={{ marginTop: 8, color: "#8c8c8c" }}>{email}</div>}
            </>
          }
          extra={
            <Button type="primary" loading={busy} onClick={signOut}>
              {t("logout")}
            </Button>
          }
        />
      </Card>
    </div>
  );
};

export default AccessDenied;
